var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenTickSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    width: 30,
    height: 30,
    rx: 8,
    fill: "#0DBA78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3312 20.25C13.0788 20.2498 12.8343 20.1545 12.6392 19.9802L9.37607 17.0686C8.92987 16.6463 8.87283 15.9142 9.24731 15.4161C9.6218 14.9181 10.292 14.8347 10.76 15.2279L13.2875 17.4811L20.5712 10.1741C20.845 9.81955 21.2828 9.67027 21.6933 9.79153C22.1039 9.91278 22.4125 10.2825 22.4843 10.7392C22.5561 11.1958 22.3781 11.6564 22.028 11.9196L14.0741 19.9326C13.8728 20.138 13.607 20.2516 13.3312 20.25Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickSquare);
export default __webpack_public_path__ + "static/media/greenTickSquare.d12f3deb7c729d0b8189ce5d29440380.svg";
export { ForwardRef as ReactComponent };